import React from 'react'
import { Card, CardText, CardImg, CardFooter  } from 'reactstrap'
import { catColors } from './Colors'
import '../../../CSS/UI Components/CategoryCard.css'
import { useMediaQuery } from 'react-responsive'


import {FiArrowRight} from 'react-icons/fi'

let catImages = {
    "Beauty": "https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1767685049310-lg.webp",
    "Cleaning": "https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1767685050196-lg.webp",
    "Appliance Services": "https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1767685054108-lg.webp",
    "Electrical": "https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1767685121900-lg.webp",
    "Nail Care": "https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1767685052101-lg.webp",
    "Hair Care": "https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1767685051046-lg.webp",
    "Auto Care": "https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1767689361444-lg.png",
}

export default function CategoryCards(props) {
    const imageSrc = catImages[props.categoryName] || props.uri;
    return (
        <div>
            <Card style={{ ...props.style }} onClick={props.onClick} className="categoryCardStyle">
                <CardImg
                    // className='categoryImg_Style'
                    style={{ height: '100%', width:  '100%'}}
                    src={imageSrc}
                />
                <div style={{position:'absolute',bottom:10, flexDirection:'row', display:'flex', justifyContent:'space-between', width:'100%', paddingLeft:10, paddingRight:10}}>
                    <text className="categoryCardText">{props.categoryName}</text>
                    <div style={{
                        width: 15,
                        height: 15,
                        borderRadius: 10,
                        backgroundColor: "#e8e8e8",
                        justifyContent: 'center',
                        alignItems: 'center',
                        display: 'flex'
                    }}>
                        <FiArrowRight size={10}  color={"rbga(0,0,0,0.2)"}/>
                    </div>
                </div>
            </Card>
        </div>
    )
}